import ZoomInIcon from '@mui/icons-material/ZoomIn';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import {
  MapZoomModeEnum,
  selectZoomMode,
  setZoomMode,
} from '../../../mapSlice';
import MapButtonMenuPopup from '../../settingsMenu/MapButtonMenuPopup';
import { MapButtonWithTooltip } from '../../settingsMenu/MapButtonWithTooltip';
import { RadioButtonGroup } from '../../settingsMenu/RadioButtonGroup';

export const MapZoomModeButton = () => {
  const dispatch = useAppDispatch();
  const zoomMode = useAppSelector(selectZoomMode);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setZoomMode(event.target.value as MapZoomModeEnum));
  };

  const zoomModeOptions = [
    { value: MapZoomModeEnum.blockLevel },
    { value: MapZoomModeEnum.pointLevel },
    { value: MapZoomModeEnum.manual },
  ];

  const mapZoomModePopup = (
    <MapButtonMenuPopup title={'Zoom Mode'}>
      <RadioButtonGroup
        value={zoomMode}
        options={zoomModeOptions}
        handleChange={handleChange}
        ariaLabel={'zoom-mode'}
      />
    </MapButtonMenuPopup>
  );

  return (
    <MapButtonWithTooltip
      icon={<ZoomInIcon />}
      popupComponent={mapZoomModePopup}
    />
  );
};
